/* eslint-disable no-useless-catch */
/* eslint-disable unused-imports/no-unused-vars */
import { BAG, BAG_SUGGESTION } from "../constants/url.constant";

import { API } from "../api";

export const GET_ALL_BAGS = "GET_ALL_BAGS";
export const DELETE_BAG = "DELETE_BAG";
export const GET_CLIENT_PICKUP_REQUEST = "GET_CLIENT_PICKUP_REQUEST";
export const SET_CLIENT_PICKUP_LIST = "SET_CLIENT_PICKUP_LIST";

export const uploadAWBFile = (fileData) => {
  return async (dispatch) => {
    try {
      return await API.post(`${BAG}/upload-awb`, fileData);
    } catch (error) {
      throw error;
    }
  };
};

export const getBags = (bagId) => {
  return async (dispatch) => {
    try {
      const res = await API.get(`${BAG_SUGGESTION}/${bagId}`);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getBagOrders = (bagId) => {
  return async (dispatch) => {
    try {
      const res = await API.get(`${BAG}/${bagId}/orders`);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const createBag = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(BAG, data);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getAllBags = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(BAG, {
        params: params
      });
      dispatch({
        type: GET_ALL_BAGS,
        payload: res
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getBagById = (id) => {
  return async (dispatch) => {
    try {
      const res = await API.get(`${BAG}/${id}`);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateBag = (id, data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${BAG}/${id}`, data);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const removeBagOrder = (bagId, orderId) => {
  return async (dispatch) => {
    try {
      const res = await API.delete(`${BAG}/${bagId}/orders/${orderId}/`);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const removeBag = (id) => {
  return async (dispatch) => {
    try {
      const res = await API.delete(`${BAG}/${id}`);
      dispatch({
        type: DELETE_BAG,
        payload: id
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

const initialState = {
  columns: [],
  data: [],
  totalRows: 0,
  order: {}
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_ALL_BAGS:
      return {
        ...state,
        columns: payload.columns,
        data: payload.rows,
        totalRows: payload.count
      };
    case DELETE_BAG:
      return {
        ...state,
        totalRows: state.totalRows - 1,
        data: state.data.filter((bag) => bag.id !== payload)
      };
    default:
      return state;
  }
}
